import {
  Button,
  Col,
  Divider,
  Drawer,
  Dropdown,
  Flex,
  Grid,
  Menu,
  Row,
  Space,
  Typography,
} from "antd";
import BEVZsvg from "../../../assets/v2/bevzTextLogo.svg";
import {
  CloseOutlined,
  DownOutlined,
  LogoutOutlined,
  MenuOutlined,
} from "@ant-design/icons";
import {
  ACTIONTYPES,
  useStore,
  useStoreDispatch,
} from "../../../context/CreateStoreContext";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

const { Text, Paragraph } = Typography;
const { useBreakpoint } = Grid;

export default function Navigation() {
  const { loginDetails } = useStore();
  const dispatch = useStoreDispatch();
  const navigate = useNavigate();
  const screen = useBreakpoint();
  const [open, setOpen] = useState(false);

  const items = [
    { label: "Support", key: "support" },
    { type: "divider" },
    { label: "Logout", key: "logout", icon: <LogoutOutlined /> },
  ];

  const onClick = ({ key }) => {
    switch (key) {
      case "logout":
        dispatch({ type: ACTIONTYPES.CLEARSTATES });
        navigate("/login", { replace: true });
        break;
      case "support":
        window.open("https://www.bevz.com/support", "_blank");
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    screen.xs === false && setOpen(false);
  }, [screen]);

  return (
    <>
      <Row align="middle" justify="space-between">
        <Col xs={{ offset: 1 }} md={{ offset: 0 }}>
          <img src={BEVZsvg} alt="Bevz." />
        </Col>
        <Col xs={{ pull: 1 }} md={{ pull: 0 }}>
          {screen.xs ? (
            <Button
              icon={<MenuOutlined />}
              onClick={() => setOpen(true)}
              type="text"
              size="large"
            />
          ) : (
            <Dropdown menu={{ items, onClick }}>
              <Space>
                <Text style={{ fontSize: "16px" }}>
                  {loginDetails?.storeDetails?.email}
                </Text>{" "}
                <DownOutlined />
              </Space>
            </Dropdown>
          )}
        </Col>
      </Row>
      <Drawer
        open={open}
        onClose={() => setOpen(false)}
        title={loginDetails?.storeDetails?.email}
        classNames={{ header: "BEVZ_drawer_header" }}
      >
        <Space direction="vertical" style={{ width: "100%" }} size={12}>
          {items.map(
            (item) =>
              item.type !== "divider" && (
                <Button
                  key={item.label}
                  color="default"
                  variant="filled"
                  block
                  size="large"
                  onClick={() => onClick(item)}
                  icon={item.icon}
                  style={{ justifyContent: "flex-start" }}
                >
                  {item.label}
                </Button>
              ),
          )}
        </Space>
      </Drawer>
    </>
  );
}
